import React, { FC } from 'react';

export const IconCloseThin: FC<React.PropsWithChildren<{ className?: string; width?: number; height?: number }>> = ({ className, width = 18, height = 18 }) => (
  // @ts-ignore slot attribute is required for market, but not part of the React svg type.
  <svg slot="icon" className={className} width={width} height={height} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M17 1L1 17" stroke="currentColor" />
    <path d="M1 1L17 17" stroke="currentColor" />
  </svg>
);
